import styled, { useTheme } from 'styled-components';
import Modal from '../../../components/Modal';
import { BodyLarge, ParagraphLargeText } from '../../../components/Texts';
import Button from '../../../components/Button';

const ContentContainer = styled.div`
  width: 100%;
  overflow: hidden;
  text-align: center;
`;

const StyledModal = styled(Modal)`
  .modal-content {
    overflow: hidden;
    max-height: 700px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-top: 16px;
`;

const ConfirmationModal = ({
  onClose,
  onContinue,
  title,
  text,
  onCancel,
  doNotClose = false,
}) => {
  const theme = useTheme();

  return (
    <StyledModal
      onClose={() => {
        onClose();
        if (onCancel) {
          onCancel();
        }
      }}
    >
      <ContentContainer>
        <ParagraphLargeText style={{ color: theme.text.title }}>
          {title}
        </ParagraphLargeText>
        <BodyLarge>{text}</BodyLarge>
        <ButtonContainer>
          <Button
            onClick={async () => {
              await onContinue();
              if (!doNotClose) {
                onClose();
              }
            }}
          >
            Continue
          </Button>
        </ButtonContainer>
      </ContentContainer>
    </StyledModal>
  );
};

export default ConfirmationModal;
